import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import { useFilters, usePagination, useTable } from 'react-table';
import { Button, Input } from 'reactstrap';
import { COLUMNS } from '../../data/column.js';
import { ColumnFilter } from '../../functions/ColumnFilter';
import './home.css';
import { DotLoader } from "react-spinners";


const Home = (props) => {

    const columns = useMemo(() => COLUMNS(props), [])
    const [data, setData] = useState([])
    const [isLoading, setLoading] = useState(true)
    const restAPI = () => {
        axios
            .get('/api/v2/admin/transactions/', {
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(res => {
                setData(res.data.data)
                setLoading(false)

            })
            .catch(err => console.log(err));
    }

    useEffect(() => {
        restAPI();
    }, [])

    const defaultColumn = React.useMemo(
        () => ({
            Filter: ColumnFilter
        }),
        []
    )

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        state,
        gotoPage,
        pageCount,
        setPageSize,
        prepareRow,

    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            initialState: { pageIndex: 0 }
        },
        useFilters,
        usePagination,
    )

    const { pageIndex, pageSize } = state


    return (
        <div>
            {isLoading ? <div className="vw-100 vh-100 d-flex align-items-center justify-content-center">
                <DotLoader sizeUnit="px" size={50} color="#00DD8C" />
            </div> : <div> <table {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (

                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th {...column.getHeaderProps()}>
                                    {column.render('Header')}
                                    <div>{column.canFilter ? column.render('Filter') : null}</div>
                                </th>


                            ))}

                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row)
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                })}

                            </tr>
                        )
                    })}
                </tbody>
            </table>
                <div className='pagination'>
                    <Button color="primary" outline onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        {'<<'}
                    </Button>{' '}
                    <Button color="primary" outline onClick={() => previousPage()} disabled={!canPreviousPage}>
                        Previous
                    </Button>{' '}
                    <Button color="primary" outline onClick={() => nextPage()} disabled={!canNextPage}>
                        Next
                    </Button>{' '}
                    <Button color="primary" outline onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        {'>>'}
                    </Button>{' '}
                    <span style={{ margin: '5px' }} className={`d-flex align-items-center`}>
                        Page{' '}
                        <strong>
                            {pageIndex + 1} of {pageOptions.length}
                        </strong>{' '}
                    </span>
                    {/* <span>
            | Go to page:{' '}
            <input
                type='number'
                defaultValue={pageIndex + 1}
                onChange={e => {
                    const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
                    gotoPage(pageNumber)
                }}
                style={{ width: '50px' }}
            />
        </span>{' '} */}
                    <Input
                        style={{ width: '150px', margin: '0px 10px' }}
                        name="select"
                        type="select"
                        value={pageSize}
                        onChange={e => setPageSize(Number(e.target.value))}>
                        {[10, 50, 100, 200, 500].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize} line
                            </option>
                        ))}
                    </Input>
                </div></div>}
        </div>
    )
}

export default Home;


// WEBPACK FOOTER //
// ./client/react/Admin/views/Transactions/index.js